import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@mui/material';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  content: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export default function ConfirmModal({
  open,
  title,
  content,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel,
  loading = false
}: ConfirmModalProps) {
  return (
    <Dialog 
      open={open} 
      onClose={!loading ? onCancel : undefined} 
      maxWidth="xs" 
      fullWidth
      sx={{
        '& .MuiDialog-paper': { borderRadius: '12px', padding: 1 }
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, color: 'text.primary' }}>{title}</DialogTitle>
      <DialogContent>
        {typeof content === 'string' ? (
          <Typography color="text.secondary">{content}</Typography>
        ) : (
          content
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button 
          onClick={onCancel} 
          disabled={loading} 
          color="inherit" 
          sx={{ textTransform: 'none', borderRadius: '8px' }}
        >
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          disabled={loading} 
          variant="contained" 
          color="primary" 
          sx={{ textTransform: 'none', borderRadius: '8px', minWidth: 110 }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
